export default {
  path: '/auth',
  name: 'auth',
  redirect: { name: 'auth.login-page' },
  component: () => import(/* webpackChunkName: "auth" */ '@/views/auth'),
  children: [
    {
      path: '/login',
      name: 'auth.login-page',
      meta: { requiresNotAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "login-page" */ '@/views/auth/LoginPage.vue'
        )
    },
    {
      path: '/register',
      name: 'auth.register-page',
      meta: { requiresNotAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "register-page" */ '@/views/auth/RegisterPage.vue'
        )
    },
    {
      path: '/verify/:id',
      name: 'auth.verify-page',
      meta: {
        requiresAuth: true,
        fullScreen: true,
        hideHeaderMenu: true,
        hideFooter: true
      },
      component: () =>
        import(
          /* webpackChunkName: "verify-page" */ '@/views/auth/VerifyPage.vue'
        )
    },
    {
      path: '/onboarding-profile',
      meta: { requiresAuth: true, hideHeaderMenu: true },
      name: 'auth.onboarding-profile-page',
      component: () =>
        import(
          /* webpackChunkName: "onboarding" */ '@/views/auth/OnboardingProfilePage.vue'
        )
    },
    {
      path: '/onboarding-id',
      meta: { requiresAuth: true, hideHeaderMenu: true },
      name: 'auth.onboarding-id-page',
      component: () =>
        import(
          /* webpackChunkName: "onboarding" */ '@/views/auth/OnboardingIDPage.vue'
        )
    }
  ]
}
